import { render, staticRenderFns } from "./miniProgram.vue?vue&type=template&id=344343b2&scoped=true&"
import script from "./miniProgram.vue?vue&type=script&lang=js&"
export * from "./miniProgram.vue?vue&type=script&lang=js&"
import style0 from "./miniProgram.vue?vue&type=style&index=0&id=344343b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344343b2",
  null
  
)

export default component.exports